module.exports = __webpack_public_path__ + "assets/img/search.1fe5b4d7.png";